module.exports = __webpack_public_path__ + "static/Crowns 2 intraoral after-54a094b2eec2bce9af1f8c7e723cadb0.jpg";